/**
 * Coil Calculator logic.
 *
 * Revisions:
 *     Created the code. Daniel Khadivi, 2019-01-18.
 */ 
var WI_library = function() {
    return {
        'each': function each(collection, func) {
            for (var i = 0; i < collection.length; ++i) {
                func.apply(collection[i], [i, collection[i], collection]);
            }
        },
        'eachProperty': function each(collection, func) {
            for (var i in collection) {
                if (collection.hasOwnProperty(i)) {
                    func.apply(collection[i], [i, collection[i], collection]);
                }
            }
        },
        /* Generate c_!ap_t_chA values.
         * Changes:
         *   DAK 6/26/2017: Created the function.
         */
        generateCaptcha: function(elSelector) {
            var el = document.querySelector(elSelector);

            if(!this.isNull(el)) {
                var a = Math.ceil(Math.random() * 9)+ '';
                var b = Math.ceil(Math.random() * 9)+ '';
                var c = Math.ceil(Math.random() * 9)+ '';
                var d = Math.ceil(Math.random() * 9)+ '';
                var e = Math.ceil(Math.random() * 9)+ '';
                //var f = Math.ceil(Math.random() * 9)+ '';
                //var g = Math.ceil(Math.random() * 9)+ '';

                el.innerHTML = a + ' ' + b + ' ' + ' ' + c + ' ' + d + ' ' + e; //  + ' ' + f + ' ' + g;
            }
        },
        /* sp!_am-b!ot check.
         * Changes:
         *   DAK 6/27/2017: Created the function.
         */
        napeydahIsValid: function() {
            var ret = false;
            var fld = document.querySelector('.napeydah');

            if(!this.isNull(fld) && this.isNullOrEmpty(fld.value)) {
                ret = true;
            }
            return ret;
        },
        /* If in strict mode (default): The specified value is an integer if it is a number and it does not have a
         * remainder with a modulus operation.
         *
         * If not in strict mode (i.e. the second parameter is 'true'): The above is true but a
         * string value is also checked to see if it contains an integer value.
         *
         * Changes:
         *   DAK 12/14/2018: Created the function.
         */
        /* DAK 20181212: RFQ */
        'isInt': function isInt(value, notStrict, positiveOnly) {
            var ret = false;
            if(notStrict === true) {
                if(typeof value === 'string') {
                    ret = ((positiveOnly === true) ?  /^\+?(0|[1-9]\d*)$/.test(value) : /^(\-|\+)?(0|[1-9]\d*)$/.test(value));
                }
            }
            else {
                ret = (typeof value === 'number' && value % 1 === 0);
            }
            return ret;
        },
        /* Is the specified value null or 'undefined'?
         * Changes:
         *   DAK 6/26/2017: Created the function.
         */
        'isNull': function isNull(val) {
            return (val == undefined || val == null) ? true : false;
        },
        /* Is the specified value null, 'undefined' or, if a string, an empty string?
         * Changes:
         *   DAK 6/26/2017: Created the function.
         *   DAK 7/05/2017: Added the "trim" method.
         */
        'isNullOrEmpty': function isNullOrEmpty(val) {
            return (this.isNull(val) || (typeof(val) == "string" && val.trim().length == 0)) ? true : false;
        },
        /* Remove all the spaces from the specified value.
         * Changes:
         *   DAK 6/26/2017: Created the function.
         */
        'removeSpaces': function removeSpaces(val) {
            return (!this.isNullOrEmpty(val)) ? val.split(' ').join('') : '';
        },
        'RxEmitter': (function RxEmitter() {
            function Emitter() {
                this.subjects = {};
            }
            Emitter.prototype.emit = function (name, data) {
                var subjectName = '$' + name;
                this.subjects[subjectName] || (this.subjects[subjectName] = new Rx.Subject());
                this.subjects[subjectName].onNext(data);
            };
            Emitter.prototype.listen = function (name, handler) {
                var subjectName = '$' + name;
                this.subjects[subjectName] || (this.subjects[subjectName] = new Rx.Subject());
                return this.subjects[subjectName].subscribe(handler);
            };
            Emitter.prototype.dispose = function () {
                var subjects = this.subjects;
                for (var prop in subjects) {
                    if (subjects.hasOwnProperty(prop)) {
                        subjects[prop].dispose();
                    }
                }
                this.subjects = {};
            };
            return Emitter;
        })(),
        'toastMessage': function toastMessage(msg, msgType, msgPosition) {
            toastr.options.positionClass = (!this.isNullOrEmpty(msgPosition) && "toast-bottom-left;toast-bottom-center;toast-bottom-right;toast-bottom-full-width".indexOf(msgPosition) >= 0) ? msgPosition : "toast-bottom-center"
            toastr.options.extendedTimeOut = 0
            toastr.options.timeOut = 3500
            toastr.options.showMethod = 'slideDown'
            toastr.options.preventDuplicates = true
            toastr.options.progressBar = true

            switch(msgType) {
                case "error":
                    toastr.error(msg)
                    break;
                case "info":
                    toastr.info(msg)
                    break;
                case "success":
                    toastr.success(msg)
                    break;
                case "warning":
                    toastr.warning(msg)
                    break;
                default:
                    toastr.success(msg)

            }
        },
        'userAgent': {
            Android: function() {
                return /Android/i.test(navigator.userAgent);
            },
            BlackBerry: function() {
                return /BlackBerry/i.test(navigator.userAgent);
            },
            iOS: function() {
                return /iPhone|iPad|iPod/i.test(navigator.userAgent);
            },
            Windows: function() {
                return /IEMobile/i.test(navigator.userAgent);
            },
            Safari: function() {
                return /Safari/i.test(navigator.userAgent);
            },
            Chrome: function() {
                return /Chrome/i.test(navigator.userAgent);
            }
        },
        'validateEmail': function validateEmail(email) {
            return /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i.test(email);
        },
        'Validate': {
            cap: function(generatedVal, enteredVal) {
                var ret = false
                if(!WI_library.isNullOrEmpty(generatedVal) && !WI_library.isNullOrEmpty(enteredVal)) {
                    // Remove all the spaces from both values then compare.
                    ret = (enteredVal.replace(/\s/g, "") === generatedVal.replace(/\s/g, "")) ? true : false
                }
                return ret
            },
            date: function(value, watermark) {
                var ret = false
                if(!WI_library.isNullOrEmpty(value)) {
                    // Remove the watermark then validate only if it's not empty.
                    var val = value.replace(watermark, "")
                    if(!WI_library.isNullOrEmpty(val)) {
                        // Remove spaces, "/" and "-".
                        val = val.replace(/\s|\/|-/g, "")
                        if(val.length === 8) {
                            // result[1] is year "MM", result[2] is month "DD", and result[3] is day "YYYY".
                            var result = val.match(/(\d{2})(\d{2})(\d{4})/)

                            // The RegEx test failed if "result" is not an object and it doesn't contain three values.
                            if(result === null || typeof(result) !== 'object' || result.length != 4) {
                                return ret
                            }

                            var ret = true
                            var resYear = parseInt(result[3], 10)
                            var resMon  = parseInt(result[1], 10)
                            var resDay  = parseInt(result[2], 10)

                            // Check the year.
                            if(resYear < 1970 || resYear > 2050) {
                                ret = false
                            }

                            // Check the month.
                            if((ret === true) && (resMon < 1 || resMon > 12)) {
                                ret = false
                            }

                            // Check the day.
                            if((ret === true) && ((resDay < 1  || resDay > 31) || ([4,6,9,11].indexOf(resMon) > -1 && resDay > 30))) {
                                ret = false
                            }

                            // Check February.
                            if((ret === true) && ((resMon === 2 && resDay > 29) || (resMon === 2 && resDay > 28 && resYear % 4 != 0))) {
                                ret = false
                            }
                        }
                    }
                    else {
                        ret = true
                    }
                }
                else {
                    ret = true
                }
                return ret
            },
            email: function(value, watermark) {
                var ret = true
                if(!WI_library.isNullOrEmpty(value)) {
                    // Remove the watermark then validate only if it's not empty.
                    var val = value.replace(watermark, "")
                    if(!WI_library.isNullOrEmpty(val)) {
                        ret = (val.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) == null) ? false : true
                    }
                }
                return ret
            },
            phone: function(value, watermark) {
                var ret = true
                if(!WI_library.isNullOrEmpty(value)) {
                    // Remove the watermark then validate only if it's not empty.
                    var val = value.replace(watermark, "")
                    if(!WI_library.isNullOrEmpty(val)) {
                        // Remove all the following before validating: spaces, ")", "(", and "-".
                        ret = (val.replace(/\s|\(|\)|-/g, "").match(/^[0-9]{6,}$/) == null) ? false : true
                    }
                }
                return ret
            },
            textRequired: function(value, watermark) {
                var ret = false

                if(!WI_library.isNullOrEmpty(watermark)) {
                    ret = (WI_library.isNullOrEmpty(value) || (value.toLowerCase().indexOf(watermark.toLowerCase()) >= 0)) ? false : true
                }
                else {
                    ret = (WI_library.isNullOrEmpty(value)) ? false : true
                }
                return ret
            },
        }
    }
}();
 var wiCoilCalculator = {};
 (function() {
     'use strict';
 
     this.calculationMethod = 'byDiameter'
     this.inputEls = {
         coilDiameterID: null,
         coilDiameterOD: null,
         coilDiameterWidth: null,
         coilDiameterThickness: null,
         coilWeightWeight: null,
         coilWeightWidth: null,
         coilWeightThickness: null
     }
 
     this.resultEls = {
         coilDiameterPIW: null,
         coilDiameterWeight: null,
         coilDiameterLength: null,
         coilDiameterID: null,
         coilDiameterOD: null,
         coilDiameterSidewall: null,
         coilWeightID1: null,
         coilWeightOD1: null,
         coilWeightSidewall1: null,
         coilWeightID2: null,
         coilWeightOD2: null,
         coilWeightSidewall2: null,
         coilWeightID3: null,
         coilWeightOD3: null,
         coilWeightSidewall3: null
     }
 
     this.handleCalculateByCoilDiameter = function(event) {
         //var el = event.target;
 
         if(validateCoilDiameterParameters() === true) {
             calculateByCoilDiameter()
         }
     }
 
     this.handleCalculateByCoilWeight = function(event) {
         //var el = event.target;
 
         if(validateCoilWeightParameters() === true) {
             calculateByCoilWeight()
         }
     }
 
     this.handleCalculationMethodChange = function(event) {
         var el = event.target;
         clear()
         clearErrors()
         //hideErrors()
 
         if(!WI_library.isNull(el)) {
             var calByDiameterParamEl = document.getElementById('calculationByCoilDiameter')
             var calByWeightParamEl = document.getElementById('calculationByCoilWeight')
             var sidewallByCoilEl = document.querySelector('.result.sidewallByCoil')
             var sidewallByWeightEl = document.querySelector('.result.sidewallByWeight')
 
             if(!WI_library.isNull(calByDiameterParamEl) && !WI_library.isNull(calByWeightParamEl) && !WI_library.isNull(sidewallByCoilEl) && !WI_library.isNull(sidewallByWeightEl)) {
                 switch(el.value) {
                     case 'byDiameter':
                         calByDiameterParamEl.style.display = 'table';
                         sidewallByCoilEl.style.display = 'table';
 
                         calByWeightParamEl.style.display = 'none';
                         sidewallByWeightEl.style.display = 'none';
 
                         wiCoilCalculator.calculationMethod = 'byDiameter'
                         setFocus()
                         break;
 
                     case 'byWeight':
                         calByDiameterParamEl.style.display = 'none';
                         sidewallByCoilEl.style.display = 'none';
 
                         calByWeightParamEl.style.display = 'table';
                         sidewallByWeightEl.style.display = 'table';
 
                         wiCoilCalculator.calculationMethod = 'byWeight'
                         setFocus()
                         break;
                 }
             }
         }
     }
 
     this.handleClear = function(event) {
         //var el = event.target;
 
         clear()
     }
 
     //
     //  Private functions.
     var addErrorClass = function(el, addError, isDropDown) {
         var ret = null;
 
         if(WI_library.isNull(el)) {
             return ret;
         }
 
         if(addError === true) {
             if(isDropDown === true) {
                 el.classList.remove('DropDownField');
                 el.classList.add('DropDownField-X');
             }
             //el.setAttribute('is-invalid', '1')
             el.classList.add('input-validation-error');
         }
         else {
             el.classList.remove('input-validation-error');
             if(isDropDown === true) {
                 el.classList.add('DropDownField');
                 el.classList.remove('DropDownField-X');
             }
         }
     }
 
     var calculateByCoilDiameter = function() {
         var inputEls = wiCoilCalculator.inputEls
         var resultEls = wiCoilCalculator.resultEls
 
         var id = parseFloat(inputEls.coilDiameterID.value)
         var od = parseFloat(inputEls.coilDiameterOD.value)
         var width = parseFloat(inputEls.coilDiameterWidth.value)
         var thickness = parseFloat(inputEls.coilDiameterThickness.value)
 
         if(!WI_library.isNull(resultEls.coilDiameterWeight)) {
             var weight = ((Math.PI * Math.pow((od/2),2) * 0.2833) - (Math.PI * Math.pow((id/2), 2) * 0.2833)) * width
             resultEls.coilDiameterWeight.innerHTML = weight.toFixed(1)
 
             if(!WI_library.isNull(resultEls.coilDiameterLength)) {
                 var length = weight/(width * thickness * 0.2833 * 12)
                 resultEls.coilDiameterLength.innerHTML = length.toFixed(1)
             }
 
             if(!WI_library.isNull(resultEls.coilDiameterPIW)) {
                 var piw = weight/width
                 resultEls.coilDiameterPIW.innerHTML = piw.toFixed(1)
             }
         }
 
         if(!WI_library.isNull(resultEls.coilDiameterID)) {
             resultEls.coilDiameterID.innerHTML = id
         }
 
         if(!WI_library.isNull(resultEls.coilDiameterOD)) {
             resultEls.coilDiameterOD.innerHTML = od
         }
 
         if(!WI_library.isNull(resultEls.coilDiameterSidewall)) {
             var sidewall = (od - id)/2
             resultEls.coilDiameterSidewall.innerHTML = sidewall.toFixed(1)
         }
     }
 
     var calculateByCoilWeight = function() {
         var inputEls = wiCoilCalculator.inputEls
         var resultEls = wiCoilCalculator.resultEls
 
         var weight = parseFloat(inputEls.coilWeightWeight.value)
         var width = parseFloat(inputEls.coilWeightWidth.value)
         var thickness = parseFloat(inputEls.coilWeightThickness.value)
 
         if(!WI_library.isNull(resultEls.coilDiameterWeight)) {
             resultEls.coilDiameterWeight.innerHTML = weight
 
             if(!WI_library.isNull(resultEls.coilDiameterPIW)) {
                 var piw = weight/width
                 resultEls.coilDiameterPIW.innerHTML = piw.toFixed(1)
             }
 
             if(!WI_library.isNull(resultEls.coilDiameterLength)) {
                 var length = weight/(width * thickness * 0.2833 * 12)
                 resultEls.coilDiameterLength.innerHTML = length.toFixed(1)
             }
 
             var idResult = null
             var odResult = null
             var sideWallResult = null
             if(!WI_library.isNull(resultEls.coilWeightID1)) {
                 idResult = 16
                 resultEls.coilWeightID1.innerHTML = idResult
 
                 if(!WI_library.isNull(resultEls.coilWeightOD1)) {
                     odResult = 2 * Math.sqrt(((weight/width) + (Math.PI * Math.pow((idResult/2),2) * 0.2833)) / .889562)
                     resultEls.coilWeightOD1.innerHTML = odResult.toFixed(1)
 
                     if(!WI_library.isNull(resultEls.coilWeightSidewall1)) {
                         sideWallResult = (odResult - idResult) / 2
                         resultEls.coilWeightSidewall1.innerHTML = sideWallResult.toFixed(1)
                     }
                 }
             }
 
             if(!WI_library.isNull(resultEls.coilWeightID2)) {
                 idResult = 20
                 resultEls.coilWeightID2.innerHTML = idResult
 
                 if(!WI_library.isNull(resultEls.coilWeightOD2)) {
                     odResult = 2 * Math.sqrt(((weight/width) + (Math.PI * Math.pow((idResult/2),2) * 0.2833)) / .889562)
                     resultEls.coilWeightOD2.innerHTML = odResult.toFixed(1)
 
                     if(!WI_library.isNull(resultEls.coilWeightSidewall2)) {
                         sideWallResult = (odResult - idResult) / 2
                         resultEls.coilWeightSidewall2.innerHTML = sideWallResult.toFixed(1)
                     }
                 }
             }
 
             if(!WI_library.isNull(resultEls.coilWeightID3)) {
                 idResult = 24
                 resultEls.coilWeightID3.innerHTML = idResult
 
                 if(!WI_library.isNull(resultEls.coilWeightOD3)) {
                     odResult = 2 * Math.sqrt(((weight/width) + (Math.PI * Math.pow((idResult/2),2) * 0.2833)) / .889562)
                     resultEls.coilWeightOD3.innerHTML = odResult.toFixed(1)
 
                     if(!WI_library.isNull(resultEls.coilWeightSidewall3)) {
                         sideWallResult = (odResult - idResult) / 2
                         resultEls.coilWeightSidewall3.innerHTML = sideWallResult.toFixed(1)
                     }
                 }
             }
         }
     }
 
     var clear = function() {
         // Clear all the input values.
         var inputValues = document.querySelectorAll('.input-value')
         if(!WI_library.isNull(inputValues)) {
             for(i=0; i < inputValues.length; i++) {
                 inputValues[i].value = ''
             }
         }
 
         // Clear all the result values.
         var resultValues = document.querySelectorAll('.result-value')
         if(!WI_library.isNull(resultValues)) {
             for(i=0; i < resultValues.length; i++) {
                 resultValues[i].innerHTML = ''
             }
         }
 
         setFocus()
     }
 
     var clearErrors = function() {
         var errorEl = document.querySelector('.coil-diameter-error')
         if(!WI_library.isNull(errorEl)) {
             errorEl.innerHTML = ''
         }
 
         errorEl = document.querySelector('.coil-weight-error')
         if(!WI_library.isNull(errorEl)) {
             errorEl.innerHTML = ''
         }
 
         // Remove the CSS error class and the error flag from all input parameter fields.
         var inputValues = document.querySelectorAll('.input-value')
         if(!WI_library.isNull(inputValues)) {
             for(i=0; i < inputValues.length; i++) {
                 addErrorClass(inputValues[i], false, false)
                 //inputValues[i].setAttribute('is-invalid', '0')
             }
         }
     }
 
     /*
     var hideErrors = function() {
         var errorEl = document.querySelector('.coil-diameter-error')
         if(!WI_library.isNull(errorEl)) {
             errorEl.style.display = 'none'
         }
 
         errorEl = document.querySelector('.coil-weight-error')
         if(!WI_library.isNull(errorEl)) {
             errorEl.style.display = 'none'
         }
     }
 
     var showError = function(message, isCoilDiameterError) {
         if(!WI_library.isNullOrEmpty(message)) {
             var errorEl = null
             if(isCoilDiameterError === true) {
                 errorEl = document.querySelector('.coil-diameter-error')
                 if(!WI_library.isNull(errorEl)) {
                     errorEl.style.display = 'block'
                     errorEl.innerHTML = message
                 }
             }
             else {
                 errorEl = document.querySelector('.coil-weight-error')
                 if(!WI_library.isNull(errorEl)) {
                     errorEl.style.display = 'block'
                     errorEl.innerHTML = message
                 }
             }
         }
     }
     */
 
     var setFocus = function() {
         switch(wiCoilCalculator.calculationMethod) {
             case 'byDiameter':
                 if(!WI_library.isNull(wiCoilCalculator.inputEls.coilDiameterID)) {
                     wiCoilCalculator.inputEls.coilDiameterID.focus()
                 }
                 break;
 
             case 'byWeight':
                 if(!WI_library.isNull(wiCoilCalculator.inputEls.coilWeightWeight)) {
                     wiCoilCalculator.inputEls.coilWeightWeight.focus()
                 }
             break;
         }
     }
 
     var validateCoilDiameterParameters = function() {
         var ret = true
         clearErrors()
 
         //var errorMessage = ''
         var val = null
 
         var els = wiCoilCalculator.inputEls
         if(!WI_library.isNull(els.coilDiameterID)) {
             if(!WI_library.isNullOrEmpty(els.coilDiameterID.value)) {
                 val = parseFloat(els.coilDiameterID.value)
 
                 if(!isNaN(val) && (val >= 16 && val <= 36)) {
                     var idParam = val
 
                     if(!WI_library.isNull(els.coilDiameterOD)) {
                         if(!WI_library.isNullOrEmpty(els.coilDiameterOD.value)) {
                             var odVal = parseFloat(els.coilDiameterOD.value)
 
                             if(isNaN(val) || odVal < idParam || odVal > 84) {
                                 addErrorClass(els.coilDiameterOD, true, false)
                                 ret = false
                             }
                         }
                         else {
                             addErrorClass(els.coilDiameterOD, true, false)
                             ret = false
                         }
                     }
                 }
                 else {
                     addErrorClass(els.coilDiameterID, true, false)
                     ret = false
                 }
             }
             else {
                 addErrorClass(els.coilDiameterID, true, false)
                 ret = false
             }
         }
 
         if(!WI_library.isNull(els.coilDiameterWidth)) {
             if(!WI_library.isNullOrEmpty(els.coilDiameterWidth.value)) {
                 val = parseFloat(els.coilDiameterWidth.value)
 
                 if(isNaN(val) || val < 0.250 || val > 84) {
                     addErrorClass(els.coilDiameterWidth, true, false)
                     ret = false
                 }
 
             }
             else {
                 addErrorClass(els.coilDiameterWidth, true, false)
                 ret = false
             }
         }
 
         if(!WI_library.isNull(els.coilDiameterThickness)) {
             if(!WI_library.isNullOrEmpty(els.coilDiameterThickness.value)) {
                 val = parseFloat(els.coilDiameterThickness.value)
 
                 if(isNaN(val) || val < 0.005 || val > 0.650) {
                     addErrorClass(els.coilDiameterThickness, true, false)
                     ret = false
                 }
 
             }
             else {
                 addErrorClass(els.coilDiameterThickness, true, false)
                 ret = false
             }
         }
         return ret
     }
 
     var validateCoilWeightParameters = function() {
         var ret = true
         clearErrors()
 
         //var errorMessage = ''
         var val = null
 
         var els = wiCoilCalculator.inputEls
         if(!WI_library.isNull(els.coilWeightWeight)) {
             if(!WI_library.isNullOrEmpty(els.coilWeightWeight.value)) {
                 val = parseFloat(els.coilWeightWeight.value)
 
                 if(isNaN(val) || val < 100 || val > 80000) {
                     addErrorClass(els.coilWeightWeight, true, false)
                     ret = false
                 }
             }
             else {
                 addErrorClass(els.coilWeightWeight, true, false)
                 ret = false
             }
         }
 
         if(!WI_library.isNull(els.coilWeightWidth)) {
             if(!WI_library.isNullOrEmpty(els.coilWeightWidth.value)) {
                 val = parseFloat(els.coilWeightWidth.value)
 
                 if(isNaN(val) || val < 0.250 || val > 84) {
                     addErrorClass(els.coilWeightWidth, true, false)
                     ret = false
                 }
 
             }
             else {
                 addErrorClass(els.coilWeightWidth, true, false)
                 ret = false
             }
         }
 
         if(!WI_library.isNull(els.coilWeightThickness)) {
             if(!WI_library.isNullOrEmpty(els.coilWeightThickness.value)) {
                 val = parseFloat(els.coilWeightThickness.value)
 
                 if(isNaN(val) || val < 0.005 || val > 0.65) {
                     addErrorClass(els.coilWeightThickness, true, false)
                     ret = false
                 }
             }
             else {
                 addErrorClass(els.coilWeightThickness, true, false)
                 ret = false
             }
         }
         return ret
     }
 }).call(wiCoilCalculator)
 
 // Wait until the DOM has been loaded and parsed.
 document.addEventListener('DOMContentLoaded', function(event) {
     var calculationMethods = document.querySelectorAll(".calculation-method input[type='radio']")
 
     // Add a "change" event handler to each Calculation Method radio button.
     if(!WI_library.isNull(calculationMethods)) {
         for(i=0; i < calculationMethods.length; i++) {
             calculationMethods[i].addEventListener('change', wiCoilCalculator.handleCalculationMethodChange)
         }
     }
 
     // Add a click event handler to the "Calculate by Coil Diameter" button.
     var btnEl = document.getElementById('btnCalculateByDiameter')
     if(!WI_library.isNull(btnEl)) {
         btnEl.addEventListener('click', wiCoilCalculator.handleCalculateByCoilDiameter)
     }
 
     // Add a click event handler to the "Clear by Coil Diameter" button.
     btnEl = document.getElementById('btnClearByDiameter')
     if(!WI_library.isNull(btnEl)) {
         btnEl.addEventListener('click', wiCoilCalculator.handleClear)
     }
 
     // Add a click event handler to the "Calculate by Coil Weight" button.
     btnEl = document.getElementById('btnCalculateByWeight')
     if(!WI_library.isNull(btnEl)) {
         btnEl.addEventListener('click', wiCoilCalculator.handleCalculateByCoilWeight)
     }
 
     // Add a click event handler to the "Clear by Coil Weight" button.
     btnEl = document.getElementById('btnClearByWeight')
     if(!WI_library.isNull(btnEl)) {
         btnEl.addEventListener('click', wiCoilCalculator.handleClear)
     }
 
     // Save Calculate "By Coil Diameter" DOM elements for faster access.
     var el = document.getElementById('coilDiameterID')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.inputEls.coilDiameterID = el
     }
 
     el = document.getElementById('coilDiameterOD')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.inputEls.coilDiameterOD = el
     }
 
     el = document.getElementById('coilDiameterWidth')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.inputEls.coilDiameterWidth = el
     }
 
     el = document.getElementById('coilDiameterThickness')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.inputEls.coilDiameterThickness = el
     }
 
     el = document.getElementById('coilDiameterPIW')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilDiameterPIW = el
     }
 
     el = document.getElementById('coilDiameterWeight')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilDiameterWeight = el
     }
 
     el = document.getElementById('coilDiameterLength')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilDiameterLength = el
     }
 
     el = document.getElementById('coilDiameterIDResult')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilDiameterID = el
     }
 
     el = document.getElementById('coilDiameterODResult')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilDiameterOD = el
     }
 
     el = document.getElementById('coilDiameterSidewall')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilDiameterSidewall = el
     }
 
     // Save Calculate "By Coil Weight" DOM elements for faster access.
     var el = document.getElementById('coilWeightWeight')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.inputEls.coilWeightWeight = el
     }
 
     var el = document.getElementById('coilWeightWidth')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.inputEls.coilWeightWidth = el
     }
 
     var el = document.getElementById('coilWeightThickness')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.inputEls.coilWeightThickness = el
     }
 
     el = document.getElementById('coilWeightID-1')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightID1 = el
     }
 
     el = document.getElementById('coilWeightOD-1')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightOD1 = el
     }
 
     el = document.getElementById('coilWeightSidewall-1')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightSidewall1 = el
     }
 
     el = document.getElementById('coilWeightID-2')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightID2 = el
     }
 
     el = document.getElementById('coilWeightOD-2')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightOD2 = el
     }
 
     el = document.getElementById('coilWeightSidewall-2')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightSidewall2 = el
     }
 
 
     el = document.getElementById('coilWeightID-3')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightID3 = el
     }
 
     el = document.getElementById('coilWeightOD-3')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightOD3 = el
     }
 
     el = document.getElementById('coilWeightSidewall-3')
     if(!WI_library.isNull(el)) {
         wiCoilCalculator.resultEls.coilWeightSidewall3 = el
     }
 
     if(!WI_library.isNull(wiCoilCalculator.inputEls.coilDiameterID)) {
         wiCoilCalculator.inputEls.coilDiameterID.focus()
     }
 })